import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.4142 18.01L10.9992 16.597L15.5992 11.997L10.9992 7.39699L12.4142 5.98999L18.4242 12L12.4152 18.01H12.4142ZM6.9892 18.01L5.5752 16.597L10.1752 11.997L5.5752 7.40399L6.9892 5.98999L13.0002 12L6.9902 18.01H6.9892Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronDuoRight"
);
